import { render, staticRenderFns } from "./home7.vue?vue&type=template&id=63928738&scoped=true&"
import script from "./home7.vue?vue&type=script&lang=js&"
export * from "./home7.vue?vue&type=script&lang=js&"
import style0 from "./home7.vue?vue&type=style&index=0&id=63928738&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63928738",
  null
  
)

export default component.exports